<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">
        {{ $t("lang.alarm.edit_minimum_stock") }}
      </h2>
    </div>
    <div class="page-main-content">
      <div class="container-fluid">
        <v-form @submit.prevent="submitForm" ref="form" lazy-validation>
          <div class="form-row d-flex align-items-end">
            <div class="col-md-6">
              <v-text-field
                ref="minimum_stock"
                :label="$t('lang.alarm.edit_minstock.minimum_stock')"
                outlined
                v-model="minimum_stock"
                :rules="[rules.required, rules.numberRule]"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <v-text-field
                ref="area"
                :label="$t('lang.alarm.edit_minstock.area')"
                outlined
                v-model="area"
                :rules="[rules.required, rules.numberRule]"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn text rounded type="reset" @click="$router.back()">{{
                $t("lang.alarm.edit_minstock.btn_cancel")
              }}</v-btn>
              <bx-btn type="submit" color="primary" @click="submitForm">{{
                $t("lang.alarm.edit_minstock.btn_done")
              }}</bx-btn>
            </div>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "editMinstock",
  props: ["gtin"],
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      number_of_alarm: "",
      id: "",
      minimum_stock: "",
      item_type: "",
      area: "",
      rules: {
        required: v => !!v || "Field is required",
        numberRule: v => {
          if (!isNaN(v)) {
            return true;
          } else {
            return "Enter Number only";
          }
        }
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    async getData() {
      try {
        let minstock = await this.$api.alarm.getMinStock(this.gtin);
        this.area = minstock[0].area;
        this.minimum_stock = minstock[0].minimum_stock;
        this.id = minstock[0].id;
      } catch (error) {
        console.error(error);
      } finally {
        this.shouldLoading = false;
      }
    },
    async submitForm() {
      this.shouldLoading = true;
      if (this.$refs.form.validate()) {
        try {
          let data = {
            minimum_stock: this.minimum_stock * 1,
            area: this.area * 1
          };
          // let response = await this.$api.alarm.updateMinStock(this.id, data);
        } catch (error) {
          console.error(error);
        } finally {
          this.shouldLoading = false;
        }
      }
    }
  }
};
</script>
